import { connect } from 'react-redux';

import { LoginWidget } from '../components';
import { routes } from '../constants';
import { RouteActions } from '../actions';

class RegistrationPage extends LoginWidget {
    dispatchPage(){
        this.props.dispatch(RouteActions.setAppState(routes.REGISTER));
    }
}

function select(state) {
    return {
        currentRoute: state.appState.currentRoute,
        account: state.registerAccount,
        user: state.activeUser
    }
}

export default connect(select)(RegistrationPage);



// WEBPACK FOOTER //
// ./web-app/containers/register.jsx